import React, { useContext, useMemo, useLayoutEffect } from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { useHistory } from 'react-router-dom';
import defaultData from '../../../constants/data';
import utils from '@/common/utils';
import CollectionPoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/collection-pool-list/index.js';
import PoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/pool-list';
import { logroomlist } from '@/log';

export default function RoomList({ data = defaultData, performanceApi = false }) {
  const history = useHistory();

  const { isManage } = useContext(ContextProviderMenus);

  useMemo(() => {
    logroomlist();
  }, []);

  useLayoutEffect(() => {
    if (isManage == null) return;

    // entry: 0 管理员 1 参与者
    // efficacyData: 2 效果数据
    // hideTab: 1 隐藏tab
    let queryObj = utils.parseQuery(window.location.search);

    queryObj.entry = isManage ? 0 : 1;
    delete queryObj.efficacyData;
    delete queryObj.tabName;
    queryObj.hideTab = 1;
    queryObj.activityId = queryObj.id = queryObj.id || queryObj.activityId;

    history.replace(window.location.pathname + `?${utils.formatQueryObj(queryObj)}`);
    // eslint-disable-next-line
  }, [isManage]);

  // 如果有查询参数将它push到query后面

  if (isManage == null) return null;

  // if (isManage)
  // 管理者 http://mcbeta.jd.com/dist/pages/activeManageBlock/?entry=0&activityId=10599231
  // 参与者 http://mcbeta.jd.com/dist/pages/activeEnrollBlock/?entry=1&activityId=10560802
  return isManage ? (
    <CollectionPoolList performanceApi={performanceApi} destory data={data} />
  ) : (
    <PoolList performanceApi={performanceApi} destory data={data} />
  );
  // return <Microapp data={data} destory name={name} url={url} />;

  // return 'roomList';
}
